define('uikit/extra/transition',{
  SCALE: 'scale'
});

